import { useQuery } from '@tanstack/react-query';
import UsersService from '../../services/UsersService';

export const userKeys = {
  all: ['users'],
  details: () => [...userKeys.all, 'detail'],
  detail: (id) => [...userKeys.details(), id],
  modelDetails: () => [...userKeys.all, 'model'],
  modelDetail: (id) => [...userKeys.modelDetails(), id],
};

export function useModelById(id) {
  return useQuery({
    queryKey: userKeys.modelDetail(id),
    queryFn: () => UsersService.findModelById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });
}
